<template>
  <div class="pa-4 perdidas-scrap-wrapper">
    <v-btn @click="$router.back()" class="back-btn mb-4">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <v-card class="modern-report-card elevation-2 mb-4">
        <!-- Header moderno con gradiente y botón de ayuda -->
        <div class="report-header-banner">
          <div class="d-flex align-center header-main-info">
            <div class="header-icon-box mr-3 flex-shrink-0">
              <v-icon color="white">mdi-cash-remove</v-icon>
            </div>
            <div class="header-text-block">
              <div class="font-weight-bold white--text header-company-title">
                Pérdidas por Scrap
              </div>
              <div class="header-report-subtitle">
                Valorización de costos invertidos y pérdidas económicas por
                neumáticos retirados
              </div>
            </div>
          </div>

          <div
            class="header-help-btn ml-auto flex-shrink-0 d-flex align-center"
          >
            <!-- Chip resumen en cabecera si hay resultados -->
            <v-chip
              v-if="PerdidasPorScrap && PerdidasPorScrap.length > 0"
              small
              class="d-none d-md-inline-flex mr-2 summary-header-chip"
            >
              <v-icon left x-small color="amber lighten-2">mdi-tire</v-icon>
              Scrap: <strong>{{ PerdidasPorScrap.length }}</strong>
            </v-chip>

            <v-chip
              v-if="
                PerdidasPorScrap &&
                PerdidasPorScrap.length > 0 &&
                total_perdidas
              "
              small
              class="d-none d-sm-inline-flex mr-2 summary-header-chip"
            >
              <v-icon left x-small color="red lighten-3"
                >mdi-currency-usd</v-icon
              >
              Pérdidas: <strong>${{ total_perdidas }}</strong>
            </v-chip>

            <!-- Botón de ayuda -->
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1 btn-circle-tooltip"
                  icon
                  dark
                  target="_blank"
                  :href="
                    global && global.helpdesk_url
                      ? global.helpdesk_url + 'reporte-perdidas-scrap'
                      : '#'
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="22" color="amber lighten-2"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>¿Necesitas ayuda?</span>
            </v-tooltip>
          </div>
        </div>

        <!-- Cuerpo del Reporte -->
        <v-card-text class="pa-4 pa-md-5">
          <!-- Card de Filtros de Búsqueda -->
          <v-card
            class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
          >
            <div
              class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon small color="primary" class="mr-2"
                  >mdi-filter-variant</v-icon
                >
                <span
                  class="font-weight-bold text-caption text-uppercase text--primary"
                >
                  Filtros de Búsqueda
                </span>
              </div>

              <div class="d-flex align-center" v-if="reporteConsultado">
                <v-chip
                  x-small
                  color="primary lighten-4"
                  class="primary--text font-weight-bold"
                >
                  <v-icon left x-small>mdi-check-circle</v-icon>
                  Filtros aplicados
                </v-chip>
              </div>
            </div>

            <div class="pa-4 pa-md-5">
              <!-- Fila 1: Filtros de Catálogo -->
              <v-row align="center">
                <!-- Marca -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="Marcas"
                    v-model="Item.marca"
                    label="Marca"
                    placeholder="Todas las marcas"
                    clearable
                    prepend-inner-icon="mdi-tag-outline"
                    class="field-custom"
                    @change="onMarca"
                  ></v-autocomplete>
                </v-col>

                <!-- Modelo -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="modelosPorMarca"
                    v-model="Item.modelo"
                    label="Modelo"
                    placeholder="Todos los modelos"
                    clearable
                    prepend-inner-icon="mdi-car-info"
                    class="field-custom"
                    @change="onModelo"
                  ></v-autocomplete>
                </v-col>

                <!-- Medida -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="Medidas"
                    v-model="Item.medida"
                    label="Medida"
                    placeholder="Todas las medidas"
                    clearable
                    prepend-inner-icon="mdi-ruler"
                    class="field-custom"
                    @change="onMedida"
                  ></v-autocomplete>
                </v-col>

                <!-- Condición -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="reencauches"
                    v-model="Item.condicion"
                    label="Condición"
                    placeholder="Todas las condiciones"
                    clearable
                    prepend-inner-icon="mdi-tire"
                    class="field-custom"
                    @change="onCondicion"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <!-- Separador entre Catálogo y Fechas -->
              <v-divider class="my-4"></v-divider>

              <div class="mb-3">
                <div class="d-flex align-center">
                  <v-icon small color="primary" class="mr-1"
                    >mdi-calendar-range</v-icon
                  >
                  <span
                    class="text-caption font-weight-bold text-uppercase grey--text text--darken-3"
                  >
                    Filtrar por período
                  </span>
                </div>
              </div>

              <!-- Fila 2: Fechas y Botones de Acción -->
              <v-row align="center">
                <!-- Fecha Inicial -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-text-field
                    ref="inputFechaInicial"
                    outlined
                    dense
                    hide-details="auto"
                    type="date"
                    label="Fecha inicial *"
                    v-model="Item.fecha_inicial"
                    prepend-inner-icon="mdi-calendar-start"
                    class="field-custom date-picker-clickable"
                    required
                    @click.native="abrirPickerFecha('inputFechaInicial')"
                    @click:prepend-inner="abrirPickerFecha('inputFechaInicial')"
                  ></v-text-field>
                </v-col>

                <!-- Fecha Final -->
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-text-field
                    ref="inputFechaFinal"
                    outlined
                    dense
                    hide-details="auto"
                    type="date"
                    label="Fecha final *"
                    v-model="Item.fecha_final"
                    prepend-inner-icon="mdi-calendar-end"
                    class="field-custom date-picker-clickable"
                    required
                    @click.native="abrirPickerFecha('inputFechaFinal')"
                    @click:prepend-inner="abrirPickerFecha('inputFechaFinal')"
                  ></v-text-field>
                </v-col>

                <!-- Botón Consultar -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  lg="3"
                  class="d-flex align-center"
                >
                  <v-btn
                    @click="cargarDatos()"
                    color="primary"
                    block
                    height="40"
                    class="filter-action-btn font-weight-bold"
                    :disabled="
                      !Item.fecha_inicial ||
                      !Item.fecha_final ||
                      cargandoReporte
                    "
                    :loading="cargandoReporte"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Consultar
                  </v-btn>
                </v-col>

                <!-- Botón Exportar -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  lg="3"
                  class="d-flex align-center"
                >
                  <v-btn
                    @click="exportarAExcel()"
                    color="success"
                    block
                    height="40"
                    class="filter-action-btn font-weight-bold"
                    :disabled="loadingExcel"
                    :loading="loadingExcel"
                  >
                    <v-icon left small>mdi-file-excel</v-icon>
                    Exportar
                  </v-btn>
                </v-col>
              </v-row>
              <div class="mb-3">
                <div
                  class="d-flex align-center text-caption info--text text--darken-2 font-weight-medium mt-1"
                >
                  <v-icon x-small color="info" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span>
                    Para filtrar por fechas, seleccione el rango y pulse el
                    botón
                    <strong>"Consultar"</strong>.
                  </span>
                </div>
              </div>
            </div>
          </v-card>

          <!-- Estado 1: Cargando datos -->
          <div
            v-if="cargandoReporte"
            class="chart-loading-state rounded-lg pa-10 d-flex flex-column align-center justify-center text-center my-4"
          >
            <v-progress-circular
              indeterminate
              size="52"
              width="4"
              color="primary"
              class="mb-4"
            ></v-progress-circular>
            <div
              class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
            >
              Consultando pérdidas por scrap...
            </div>
            <div class="text-caption grey--text text--darken-1">
              Calculando costos de neumáticos dados de baja, marcas y valores
              residuales perdidos
            </div>
          </div>

          <!-- Estado 2: Sin resultados -->
          <div
            v-else-if="!PerdidasPorScrap || PerdidasPorScrap.length === 0"
            class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center my-4"
          >
            <div class="empty-state-icon-circle mb-4">
              <v-icon size="48" color="amber darken-2"
                >mdi-delete-empty-outline</v-icon
              >
            </div>
            <h3 class="text-h6 font-weight-bold grey--text text--darken-3 mb-2">
              Sin registros de pérdidas por scrap
            </h3>
            <p class="text-body-2 grey--text text--darken-1 max-width-480 mb-4">
              No se encontraron neumáticos en scrap registrados para los filtros
              o rango de fechas seleccionados.
            </p>
            <v-chip outlined small color="primary" class="font-weight-medium">
              <v-icon left x-small>mdi-filter-variant</v-icon>
              Ajuste los filtros o fechas para realizar una nueva búsqueda
            </v-chip>
          </div>

          <!-- Estado 3: Resultados con Tarjetas KPI y Tabla -->
          <div v-else class="mt-4">
            <!-- Tarjetas KPI Resumen -->
            <v-row dense class="mb-4">
              <!-- KPI 1: Total Scrap -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card kpi-card--primary">
                  <div class="kpi-icon-wrap kpi-icon--primary">
                    <v-icon color="blue-grey darken-3">mdi-tire</v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <span class="kpi-label blue-grey--text text--darken-2"
                      >Total Scrap</span
                    >
                    <div class="kpi-value blue-grey--text text--darken-4">
                      {{ PerdidasPorScrap ? PerdidasPorScrap.length : 0 }}
                      <span class="text-caption font-weight-regular grey--text">
                        uds
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- KPI 2: Costo Invertido -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card kpi-card--info">
                  <div class="kpi-icon-wrap kpi-icon--info">
                    <v-icon color="cyan darken-3">mdi-cash-multiple</v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <span class="kpi-label cyan--text text--darken-4"
                      >Costo Invertido</span
                    >
                    <div class="kpi-value cyan--text text--darken-4">
                      ${{ total_costos }}
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- KPI 3: Costo Perdido -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card kpi-card--danger">
                  <div class="kpi-icon-wrap kpi-icon--danger">
                    <v-icon color="red darken-3">mdi-cash-remove</v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <span class="kpi-label red--text text--darken-4"
                      >Costo Perdido</span
                    >
                    <div class="kpi-value red--text text--darken-4">
                      ${{ total_perdidas }}
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- KPI 4: % Pérdida -->
              <v-col cols="12" sm="6" md="3">
                <div class="kpi-mini-card kpi-card--warning">
                  <div class="kpi-icon-wrap kpi-icon--warning">
                    <v-icon color="amber darken-3">mdi-chart-pie</v-icon>
                  </div>
                  <div class="flex-grow-1">
                    <span class="kpi-label amber--text text--darken-4"
                      >% de Pérdida</span
                    >
                    <div class="kpi-value amber--text text--darken-4">
                      {{ porcentajePerdida }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Card de la Tabla de Datos -->
            <v-card
              class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1"
            >
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon small color="primary" class="mr-2">mdi-table</v-icon>
                  <span
                    class="font-weight-bold text-caption text-uppercase text--primary"
                  >
                    Detalle de Neumáticos en Scrap
                  </span>
                </div>

                <div class="d-flex align-center">
                  <v-chip
                    x-small
                    color="primary lighten-4"
                    class="primary--text font-weight-bold"
                  >
                    {{ PerdidasPorScrap ? PerdidasPorScrap.length : 0 }}
                    registros
                  </v-chip>
                </div>
              </div>

              <div class="pa-2 pa-sm-4">
                <!-- Buscador rápido -->
                <v-row align="center" class="mb-3">
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="search"
                      prepend-inner-icon="mdi-magnify"
                      label="Buscar por serie, marca, modelo o motivo..."
                      single-line
                      hide-details
                      dense
                      outlined
                      clearable
                      class="field-custom"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Indicador de desplazamiento horizontal en celular -->
                <div
                  class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-1"
                >
                  <v-icon x-small color="primary" class="mr-1">
                    mdi-gesture-swipe-horizontal
                  </v-icon>
                  <span>Desliza horizontalmente para ver todos los datos</span>
                </div>

                <!-- Tabla con paginación -->
                <v-data-table
                  dense
                  :headers="headers"
                  :items="PerdidasPorScrap || []"
                  :search="search"
                  :items-per-page="15"
                  :mobile-breakpoint="0"
                  class="elevation-1 tabla-distribucion-moderna letra-10"
                  no-data-text="No hay datos para pérdidas por scrap"
                  no-results-text="No se encontraron registros coincidentes"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página:',
                    'items-per-page-options': [10, 15, 25, 50, 100],
                    'page-text': '{0}-{1} de {2}',
                  }"
                >
                  <!-- Num Serie -->
                  <template v-slot:[`item.num_serie`]="{ item }">
                    <span class="font-weight-bold grey--text text--darken-3">
                      {{ item.num_serie }}
                    </span>
                  </template>

                  <!-- Costo -->
                  <template v-slot:[`item.costo`]="{ item }">
                    <span class="blue--text font-weight-bold">
                      ${{ item.costo }}
                    </span>
                  </template>

                  <!-- Costo Perdido -->
                  <template v-slot:[`item.costo_perdido`]="{ item }">
                    <span class="red--text font-weight-bold">
                      ${{ item.costo_perdido }}
                    </span>
                  </template>

                  <!-- Filas de Totales en Pie de Tabla -->
                  <template
                    v-slot:body.append
                    v-if="PerdidasPorScrap && PerdidasPorScrap.length > 0"
                  >
                    <tr class="fila-total-general">
                      <td
                        colspan="11"
                        class="text-right font-weight-bold py-2 pr-4"
                      >
                        <div class="d-flex align-center justify-end">
                          <v-icon small color="primary" class="mr-1"
                            >mdi-sigma</v-icon
                          >
                          <span>Total general</span>
                        </div>
                      </td>
                      <td class="text-center font-weight-bold py-2">
                        <span class="blue--text font-weight-bold"
                          >${{ total_costos }}</span
                        >
                      </td>
                      <td
                        class="text-center font-weight-bold py-2"
                        style="background-color: #ffebee"
                      >
                        <span class="red--text font-weight-bold"
                          >${{ total_perdidas }}</span
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>

                <!-- Resumen de Pérdidas -->
                <v-alert
                  v-if="PerdidasPorScrap && PerdidasPorScrap.length > 0"
                  dense
                  text
                  color="info"
                  icon="mdi-information-outline"
                  class="mt-4 mb-0 rounded-lg"
                >
                  <div
                    class="d-flex flex-wrap align-center justify-space-between"
                    style="gap: 8px;"
                  >
                    <span>
                      Total costo invertido:
                      <strong class="blue--text">${{ total_costos }}</strong>
                    </span>
                    <span>
                      Total costo perdido por scrap:
                      <strong class="red--text">${{ total_perdidas }}</strong>
                    </span>
                  </div>
                </v-alert>
              </div>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import global from "@/global";

export default {
  data() {
    return {
      global,
      Item: {
        marca: null,
        modelo: null,
        medida: null,
        condicion: null,
        fecha_inicial: null,
        fecha_final: null,
      },
      mostrarTabla: true,
      cargandoReporte: false,
      loadingExcel: false,
      search: "",
      modelosPorMarca: [],
      reencauches: [
        { value: "N", text: "Nuevo" },
        { value: 1, text: "1 reencauche" },
        { value: 2, text: "2 reencauche" },
        { value: 3, text: "3 reencauche" },
        { value: 4, text: "4 reencauche" },
        { value: 5, text: "5 reencauche" },
        { value: 6, text: "6 reencauche" },
        { value: "R", text: "Más de 6 reencauche" },
      ],
      headers: [
        {
          text: "N. serie",
          value: "num_serie",
          align: "center",
          sortable: true,
          width: 130,
        },
        {
          text: "Serie del cliente",
          value: "serie_cliente",
          align: "center",
          sortable: true,
        },
        { text: "Marca", value: "marca", align: "center", sortable: true },
        { text: "Modelo", value: "modelo", align: "center", sortable: true },
        { text: "Medida", value: "medida", align: "center", sortable: true },
        {
          text: "Condición",
          value: "condicion",
          align: "center",
          sortable: true,
        },
        {
          text: "Fecha scrap",
          value: "fecha_scrap",
          align: "center",
          sortable: true,
        },
        {
          text: "Motivo scrap",
          value: "motivo",
          align: "center",
          sortable: true,
        },
        {
          text: "Rem. original",
          value: "remanente_original",
          align: "center",
          sortable: true,
        },
        {
          text: "Rem. final",
          value: "remanente_final",
          align: "center",
          sortable: true,
        },
        {
          text: "Rem. límite",
          value: "remanente_limite",
          align: "center",
          sortable: true,
        },
        { text: "Costo ($)", value: "costo", align: "center", sortable: true },
        {
          text: "Costo pérdida ($)",
          value: "costo_perdido",
          align: "center",
          sortable: true,
        },
      ],
      total_costos: 0,
      total_perdidas: 0,
      reporteConsultado: false,
    };
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),
    ...mapState("reportes", [
      "PerdidasPorScrap",
      "costo_total",
      "costo_perdido_total",
      "Marcas",
      "Modelos",
      "Medidas",
    ]),

    porcentajePerdida() {
      const costo = parseFloat(this.total_costos);
      const perdida = parseFloat(this.total_perdidas);
      if (!costo || isNaN(costo) || costo <= 0) return "0.0%";
      if (isNaN(perdida)) return "0.0%";
      return ((perdida / costo) * 100).toFixed(1) + "%";
    },
  },
  methods: {
    ...mapActions("cliente", ["ObtenerDatosCliente"]),
    ...mapActions("reportes", [
      "DatosReportePerdidasPorScrap",
      "DatosMarcasModelosMedidas",
    ]),

    abrirPickerFecha: function (refName) {
      const comp = this.$refs[refName];
      const input =
        comp && comp.$el ? comp.$el.querySelector('input[type="date"]') : null;
      if (input && typeof input.showPicker === "function") {
        try {
          input.showPicker();
        } catch (e) {
          // Ignorar si el picker ya está desplegado por el navegador
        }
      }
    },

    onMarca: async function () {
      this.modelosPorMarca = [];
      if (this.Item.marca) {
        this.Modelos.forEach((element) => {
          if (element.id_marca == this.Item.marca) {
            this.modelosPorMarca.push(element);
          }
        });
      } else {
        this.Item.modelo = null;
      }
      this.cargandoReporte = true;
      try {
        await this.DatosReportePerdidasPorScrap(this.Item);
        this.total_costos = this.costo_total;
        this.total_perdidas = this.costo_perdido_total;
        this.reporteConsultado = true;
      } finally {
        this.cargandoReporte = false;
      }
    },

    onModelo: async function () {
      this.cargandoReporte = true;
      try {
        await this.DatosReportePerdidasPorScrap(this.Item);
        this.total_costos = this.costo_total;
        this.total_perdidas = this.costo_perdido_total;
        this.reporteConsultado = true;
      } finally {
        this.cargandoReporte = false;
      }
    },

    onMedida: async function () {
      this.cargandoReporte = true;
      try {
        await this.DatosReportePerdidasPorScrap(this.Item);
        this.total_costos = this.costo_total;
        this.total_perdidas = this.costo_perdido_total;
        this.reporteConsultado = true;
      } finally {
        this.cargandoReporte = false;
      }
    },

    onCondicion: async function () {
      this.cargandoReporte = true;
      try {
        await this.DatosReportePerdidasPorScrap(this.Item);
        this.total_costos = this.costo_total;
        this.total_perdidas = this.costo_perdido_total;
        this.reporteConsultado = true;
      } finally {
        this.cargandoReporte = false;
      }
    },

    _json_to_query_string: function (json) {
      json = Object.keys(json).map((item) => {
        return (
          item +
          "=" +
          (json[item] !== undefined && json[item] !== null ? json[item] : "")
        );
      });
      return json.join("&");
    },

    exportarAExcel: async function () {
      this.loadingExcel = true;
      try {
        const url =
          axios.defaults.baseURL +
          "excel/reporteperdidasscrap?" +
          this._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            fecha_inicial: this.Item.fecha_inicial,
            fecha_final: this.Item.fecha_final,
            id_marca: this.Item.marca,
            id_modelo: this.Item.modelo,
            id_medida: this.Item.medida,
            condicion: this.Item.condicion,
          });

        const response = await axios({
          url: url,
          method: "GET",
          responseType: "blob",
        });

        // Obtener el nombre del archivo del header Content-Disposition
        let nombre_archivo = "reporte.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''([^;\n]*)/i);
          const asciiMatch = disposition.match(/filename="?([^;\n"]+)"?/i);

          if (utf8Match && utf8Match[1]) {
            nombre_archivo = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch && asciiMatch[1]) {
            nombre_archivo = asciiMatch[1];
          }
        }

        // Si el contenido es texto/html, probablemente es un error
        if (response.data.type === "text/html") {
          const text = await response.data.text();
          const res = JSON.parse(text);
          if (!res.exito) {
            alert(res.mensaje || "Ocurrió un error al generar el archivo.");
            return;
          }
        } else {
          const blob = new Blob([response.data]);
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", nombre_archivo);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } catch (error) {
        this.errorMessage = error.response?.data || "Error inesperado";
        console.error("Error al exportar a Excel:", error);
      } finally {
        this.loadingExcel = false;
      }
    },

    cargarDatos: async function () {
      if (
        this.Item.fecha_inicial == undefined ||
        this.Item.fecha_final == undefined ||
        !this.Item.fecha_inicial ||
        !this.Item.fecha_final
      ) {
        this.$alertify.error("Por favor, ingresar fechas válidas");
        return;
      }
      if (this.Item.fecha_inicial > this.Item.fecha_final) {
        this.$alertify.error(
          "Por favor, ingresar una fecha igual o mayor a la primera fecha seleccionada",
        );
        return;
      }
      this.cargandoReporte = true;
      this.reporteConsultado = true;
      try {
        await this.DatosReportePerdidasPorScrap(this.Item);
        this.total_costos = this.costo_total;
        this.total_perdidas = this.costo_perdido_total;
      } catch (error) {
        console.error("Error al cargar datos:", error);
      } finally {
        this.cargandoReporte = false;
      }
    },

    formatDecimal(value) {
      let num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toFixed(2);
    },
  },
  created: async function () {
    this.cargandoReporte = true;
    try {
      await this.DatosReportePerdidasPorScrap(this.Item);
      this.total_costos = this.costo_total;
      this.total_perdidas = this.costo_perdido_total;
      this.reporteConsultado = true;
    } catch (e) {
      console.error(e);
    } finally {
      this.cargandoReporte = false;
    }
  },
  mounted() {
    this.ObtenerDatosCliente();
    this.DatosMarcasModelosMedidas();
  },
};
</script>

<style scoped>
.perdidas-scrap-wrapper {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.back-btn {
  font-weight: bold;
  border-radius: 8px !important;
}

/* Card y Header Modernos */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-header-chip {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Card de Filtros */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background: #ffffff;
  transition: box-shadow 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 42px;
}

/* Campos de Formulario */
.field-custom ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.field-custom ::v-deep .v-input__slot:hover {
  background: #ffffff !important;
}

.field-custom ::v-deep.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

.date-picker-clickable ::v-deep input {
  cursor: pointer !important;
}

.date-picker-clickable ::v-deep .v-input__slot {
  cursor: pointer !important;
}

.filter-action-btn {
  border-radius: 8px !important;
  letter-spacing: 0.3px;
  text-transform: none;
  font-size: 0.875rem !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}

/* Mini Cards KPI */
.kpi-mini-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.kpi-mini-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.kpi-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-card--primary {
  border-color: #cbd5e1 !important;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.kpi-icon--primary {
  background: #f1f5f9;
}

.kpi-card--info {
  border-color: #bae6fd !important;
  background: linear-gradient(180deg, #ffffff 0%, #f0f9ff 100%);
}

.kpi-icon--info {
  background: #bae6fd;
}

.kpi-card--danger {
  border-color: #fecaca !important;
  background: linear-gradient(180deg, #ffffff 0%, #fef2f2 100%);
}

.kpi-icon--danger {
  background: #fecaca;
}

.kpi-card--warning {
  border-color: #fef08a !important;
  background: linear-gradient(180deg, #ffffff 0%, #fefce8 100%);
}

.kpi-icon--warning {
  background: #fef08a;
}

.kpi-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #64748b;
  line-height: 1.2;
}

.kpi-value {
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
  margin-top: 2px;
}

/* Estados Vacío y Carga */
.chart-empty-state {
  min-height: 280px;
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
}

.empty-state-icon-circle {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-loading-state {
  min-height: 280px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.max-width-480 {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

/* Tabla de Distribución */
.tabla-distribucion-moderna {
  border-radius: 8px;
  overflow: hidden;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 6px;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.tabla-distribucion-moderna ::v-deep table {
  min-width: 1250px;
  width: 100%;
}

.tabla-distribucion-moderna ::v-deep thead th {
  background-color: #334155 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  white-space: nowrap;
  height: 42px !important;
  text-align: center !important;
}

/* Sticky primera columna (N. Serie) */
.tabla-distribucion-moderna ::v-deep thead th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 5 !important;
  background-color: #334155 !important;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.15) !important;
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr:not(.fila-total-general)
  td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  background-color: #ffffff !important;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08) !important;
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr:hover:not(.fila-total-general)
  td:first-child {
  background-color: #f1f5f9 !important;
}

.tabla-distribucion-moderna ::v-deep tbody td {
  border-right: 1px solid #edf2f7;
  border-bottom: 1px solid #edf2f7 !important;
  font-size: 11px;
  padding: 6px 4px !important;
  text-align: center;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.tabla-distribucion-moderna ::v-deep tbody td:last-child {
  border-right: none;
}

.tabla-distribucion-moderna ::v-deep .v-data-footer {
  border-top: 1px solid #e0e0e0;
  font-size: 11px;
  padding: 4px 12px;
  background-color: #fafafa;
}

.tabla-distribucion-moderna ::v-deep .v-data-footer__select {
  margin-bottom: 0;
}

.tabla-distribucion-moderna ::v-deep .v-data-footer__pagination {
  font-size: 11px;
}

.tabla-distribucion-moderna ::v-deep tbody tr:hover:not(.fila-total-general) {
  background-color: #f8fafc !important;
}

.fila-total-general {
  background-color: #eceff1 !important;
  border-top: 2px solid #cfd8dc !important;
  border-bottom: 1px solid #cfd8dc !important;
}

.fila-total-general td {
  font-weight: 700 !important;
  font-size: 11px !important;
  border-right: 1px solid #cfd8dc !important;
  border-bottom: 1px solid #cfd8dc !important;
  color: #1e293b;
}

.fila-total-general td:last-child {
  border-right: none !important;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__progress {
  display: none !important;
}

.letra-10 {
  font-size: 10pt;
}

@media (max-width: 960px) {
  .tabla-distribucion-moderna ::v-deep thead th {
    font-size: 9.5px !important;
    padding: 6px 2px !important;
    min-height: 38px !important;
  }

  .tabla-distribucion-moderna ::v-deep tbody td {
    font-size: 10px !important;
    padding: 5px 2px !important;
  }
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }

  .tabla-distribucion-moderna ::v-deep .v-data-footer {
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 4px;
    gap: 6px;
  }

  .tabla-distribucion-moderna ::v-deep .v-data-footer__select {
    margin-right: 6px;
  }

  .tabla-distribucion-moderna ::v-deep .v-data-footer__pagination {
    margin: 0 4px;
  }
}
</style>
